import React from 'react';
import { Typography } from '@material-ui/core';
import { isChrome } from 'react-device-detect';
import ReactQuill, { Quill } from 'react-quill';
import GridItem from './GridItem';
import Grid from './Grid';
import 'react-quill/dist/quill.snow.css';

export const removeHTMLTags = string => string.replace(/<(?:.|\n)*?>/gm, '').replace(/&#(\d+);/g,
	dec => String.fromCharCode(dec)).replace(/&nbsp;/g, ' ');


if (isChrome) {
	const style = document.createElement('style');
	style.innerHTML = '.ql-editor{white-space: normal !important;}';
	document.head.appendChild(style);
}


const AlignStyle = Quill.import('attributors/style/align');
Quill.register(AlignStyle, true);

const RichTextInput = ({
	tags,
	errorText,
	required,
	borderless,
	styles,
	stylesQuill,
	placeholder,
	...props
}) => {
	const [state, setState] = React.useState({
		value: props.value,
		showTags: false,
		companyTags: []
	});
	const rtEditor = React.useRef(null);

	const onChange = value => {
		if (!rtEditor) {
			return;
		}
		const html = value.toString('html');

		setState({ value });
		if (props.onChange) {
			if (removeHTMLTags(html).length > 0) {
				props.onChange(
					html.replace(/<a /g, '<a target="_blank" ')
				);
			} else {
				props.onChange('');
			}
		}
	};

	const checkCharacterCount = event => {
		if (props.maxChars) {
			if (removeHTMLTags(state.value.toString()).length >= props.maxChars && event.key !== 'Backspace') {
				event.preventDefault();
			}
		}
	};


	const modules = {
		toolbar: {
			container: [
				[{ color: [] }, { background: [] }], ['bold', 'italic', 'underline', 'link', 'strike'],
				['blockquote', 'code-block', { list: 'ordered' }, { list: 'bullet' }],
				[{ header: 1 }, { header: 2 }],
				[{ align: 'justify' }], [((state.companyTags && state.companyTags.length > 0) || (tags && tags.length > 0)) ? 'custom' : '']
			],
			handlers: {}
		},
		clipboard: {
			matchVisual: false,
		},
	};

	if (styles) {
		const style = document.createElement('style');
		style.innerHTML = `.ql-editor{ ${styles} }`;
		document.head.appendChild(style);
	}

	return (
		<div style={{ height: '100%' }}>
			<Typography
				variant='body1'
				style={{ color: errorText ? 'red' : 'inherit' }}
			>
				{props.floatingText}
				{!!required && '*'}
				{!!errorText &&
					<i
						className={'fas fa-times'}
						style={{
							fontSize: '13px',
							color: 'red',
							marginLeft: '0.2em'
						}}
					/>
				}
			</Typography>
			<Grid style={{ height: '100%' }}>
				<GridItem xs={12} style={{ height: '100%' }}>
					<div
						style={{ height: '100%' }}
						onClick={event => {
							if (event.target.className === 'ql-custom') {
								setState({
									showTags: event.target
								});
							}
						}}
					>
						<ReactQuill
							value={state.value}
							onChange={onChange}
							modules={modules}
							onKeyDown={checkCharacterCount}
							placeholder={placeholder || ''}
							ref={rtEditor}
							id={props.id}
							style={{ ...stylesQuill }}
							className={`text-editor ${props.quillEditorButtonsEmpty} ${errorText ? 'text-editor-error' : ''} ${borderless ? 'borderless-text-editor' : ''}`}
						/>
						{props.maxChars &&
							<span style={{ color: removeHTMLTags(state.value.toString()).length >= props.maxChars ? 'red' : 'inherit' }}>
								{`${removeHTMLTags(state.value.toString()).length} / ${props.maxChars}`}
							</span>
						}
					</div>
				</GridItem>
			</Grid>
		</div>
	);
};

export default RichTextInput;
